import React, { Component } from 'react';
import { GoCalendar } from 'react-icons/go';
import SchedulerSchedulesShell from '../schedules/index.js';

export default class SchedulerShell extends Component {
  // Same reasoning as WorkflowsShell: this shell switches its own pane off `match`, so the Blob
  // page must not also wrap it in a "default" pane div -- see resolveShell() in pages/Blob/index.js.
  static rendersOwnVisibility = true;

  static getTabs() {
    return [
      { key: "schedules", title: "Schedules", icon: GoCalendar, isDefault: true },
    ];
  }

  render() {
    const section = this.props.match.params.section || "schedules";
    return (
      <>
        {"schedules" === section &&
          <SchedulerSchedulesShell
            app={this.props.app}
            org={this.props.org}
            blob={this.props.blob}
            revision={this.props.revision}
            match={this.props.match}
            history={this.props.history}
            location={this.props.location}
          />
        }
      </>
    );
  }
}
